import callAPiBase from './base';

const serviceDiscoveryApi = {
  get: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/serviceDiscovery',
      method: 'GET',
      useToken: true,
      title: 'serviceDiscovery - Get List',
      params,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/serviceDiscovery',
      method: 'POST',
      useToken: true,
      title: 'serviceDiscovery - Update',
      data,
    }),
};

export { serviceDiscoveryApi };
export default serviceDiscoveryApi;
